import React, { forwardRef } from 'react';
import { StackLayout } from '@leagueplatform/genesis-core';
import { StyledImg } from '../common';

export type VerticalLargeImageCardProps = {
  image: string;
  imageAltText: string;
  imageLoading?: 'lazy' | 'eager';
  children: React.ReactElement;
};

export const VerticalLargeImageCard = forwardRef<
  HTMLDivElement,
  VerticalLargeImageCardProps
>(({ image, imageAltText, children, imageLoading = 'lazy' }, ref) => (
  <StackLayout
    orientation="vertical"
    verticalAlignment="spaceBetween"
    horizontalAlignment="stretch"
    spacing="$none"
    ref={ref}
  >
    <StyledImg
      borderStartEndRadius="medium"
      borderStartStartRadius="medium"
      borderStyle="solid"
      src={image}
      width="100%"
      height="176px"
      alt={imageAltText}
      loading={imageLoading}
    />
    {children}
  </StackLayout>
));
